import { Route, Routes } from 'react-router-dom';

import AccountPage from 'pages/account';
import ForgotPasswordPage from 'pages/auth/forgot';
import LoginPage from 'pages/auth/login';
import SignupPage from 'pages/auth/signup';
import Home from 'pages/home';
import LibraryPage from 'pages/library';
import PricingPage from 'pages/pricing';
import ImprintPage from 'pages/legal/imprint';
import PrivacyPolicyPage from 'pages/legal/privacy';
import TermsPage from 'pages/legal/terms';
import UnsubscribePage from 'pages/unsubscribe';
import { GuestRoute, PricingRoute, ProtectedRoute, SubscriptionRoute } from 'routes/RouteGuards';
import { PATHS } from 'routes/paths';
import { Checkout } from 'pages/checkout';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={PATHS.home} element={<Home />} />
      <Route path={PATHS.unsubscribe} element={<UnsubscribePage />} />
      <Route path={PATHS.privacy} element={<PrivacyPolicyPage />} />
      <Route path={PATHS.terms} element={<TermsPage />} />
      <Route path={PATHS.imprint} element={<ImprintPage />} />

      <Route element={<PricingRoute redirectTo={PATHS.library} />}>
        <Route path={PATHS.pricing} element={<PricingPage />} />
      </Route>

      <Route element={<GuestRoute redirectTo={PATHS.account} />}>
        <Route path={PATHS.login} element={<LoginPage />} />
        <Route path={PATHS.signup} element={<SignupPage />} />
        <Route path={PATHS.forgotPassword} element={<ForgotPasswordPage />} />
      </Route>

      <Route element={<SubscriptionRoute redirectTo={PATHS.pricing} />}>
        <Route path={PATHS.library} element={<LibraryPage />} />
      </Route>

      <Route element={<ProtectedRoute redirectTo={PATHS.login} />}>
        <Route path={PATHS.account} element={<AccountPage />} />
      </Route>
      <Route path={PATHS.checkout} element={<Checkout />} />
    </Routes>
    
  );
}
